export const bzAgendaSettings = {
    "filters": [
        {
            "tags": [
                {
                    "name": "Summit Stage",
                    "id": 388496
                },
                {
                    "name": "Future Stage",
                    "id": 388497
                },
                {
                    "name": "Exhibition Stage",
                    "id": 399370
                },
                {
                    "name": "Najd Room",
                    "id": 403735
                },
                {
                    "name": "Yanbou Room",
                    "id": 403736
                },
                {
                    "name": "Al Omsiat Ballroom B",
                    "id": 403737
                }
            ],
            "visible": true,
            "name": "Stages",
            "id": 64994,
            "type": "multi"
        },
        {
            "tags": [
                {
                    "name": "GRIF",
                    "id": 388115
                },
                {
                    "name": "FHS",
                    "id": 389592
                },
                {
                    "name": "Experiences",
                    "id": 394512
                },
                {
                    "name": "Workshops & Pitches",
                    "id": 399371
                },
                {
                    "name": "Round Table Discussions",
                    "id": 401200
                }
            ],
            "visible": true,
            "name": "Tracks",
            "id": 64995,
            "type": "multi"
        }
    ],
    "eventId": 437114,
    "links": [
        {
            "rel": "self",
            "href": "https://api.bizzabo.com/api/agenda/settings"
        }
    ]
}